/**
 * Looks up the Subresource Integrity hash for a custom-font stylesheet URL (JET-2734).
 *
 * The hashes come from the manifest `jobshop/ui/bratenfond` publishes next to the fonts
 * (see `useFontIntegrity`), keyed by font folder name. They are not pinned here: with 149
 * font folders and a per-tenant flag, we cannot know in advance which fonts are in play,
 * and a font missing from a hardcoded map would silently get no attribute at all.
 *
 * Note the scope. SRI covers the stylesheet only; the `.woff` files it references via
 * `url()` cannot carry an integrity attribute, and no mechanism exists for that. Pinning
 * the font origin including the font files is the Content Security Policy's job.
 */

/** Matches the font folder in a `.../fonts/<Font>/style.css` URL. */
const FONT_STYLESHEET_RE = /\/fonts\/([^/]+)\/style\.css(?:[?#]|$)/

/**
 * Returns the integrity hash for a font stylesheet URL, or undefined when the manifest
 * does not list that font or the URL is not a font stylesheet at all.
 */
export function getFontStylesheetIntegrity(
  href: string,
  manifest: Record<string, string>,
): string | undefined {
  const font = FONT_STYLESHEET_RE.exec(href)?.[1]

  return font ? manifest[font] : undefined
}
